import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import AuthService from '../services/auth.service';
import { decodeIdToken, decodeMetadataToken } from '../utils/token.utils';
import chargebeeService from '../services/chargebee.service';
// import { CleverTapService } from '../utils/clevertap.utils';

const SSOCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const handleSsoCallback = async () => {
            try {
                const code = searchParams.get('code');
                const state = searchParams.get('state');
                
                if (!code) {
                    throw new Error('No authorization code received');
                }

                // Parse state to get planId and register flag if they exist
                let planId = localStorage.getItem('planId') || 'All-In-One-USD-Monthly-250';
                let isRegistration = false;
                let utmParams: string | undefined = undefined;
                let provider = 'Unknown';
                
                let stateData: any;
                if (state) {
                    try {
                        stateData = JSON.parse(state);
                        if (stateData.planId) {
                            planId = stateData.planId;
                        }
                        isRegistration = stateData.isRegistration || false;
                        if(stateData.utm_params && Object.keys(stateData.utm_params).length > 0) {
                            utmParams = JSON.stringify(stateData.utm_params);
                        }
                        // Extract provider from state if available
                        if (stateData.provider) {
                            provider = stateData.provider;
                        }
                    } catch (e) {
                        console.error('Error parsing state:', e);
                    }
                }

                // Track SSO callback initiated
                // const ssoCallbackData = {
                //     'Provider': provider,
                //     'Is Registration': isRegistration,
                //     'Plan ID': planId,
                //     'Page Title': document.title,
                //     'Page URL': window.location.href,
                //     'Timestamp': new Date().toISOString(),
                // };
                // CleverTapService.trackEvent('SSO Callback Initiated', ssoCallbackData);

                // Exchange code for user info
                const response = await AuthService.getTokensFromCode(code, isRegistration, isRegistration && !planId, utmParams);

                // Clear UTM params from localStorage
                localStorage.removeItem('utm_source');
                localStorage.removeItem('utm_medium');
                localStorage.removeItem('utm_campaign');
                localStorage.removeItem('utm_content');
                localStorage.removeItem('utm_term');
                
                if(response.data.linkAccounts) {
                    // Track account linking required
                    // const linkAccountData = {
                    //     'Provider': provider,
                    //     'Page Title': document.title,
                    //     'Page URL': window.location.href,
                    //     'Timestamp': new Date().toISOString(),
                    // };
                    // CleverTapService.trackEvent('Account Linking Required', linkAccountData);
                    
                    navigate('/link-account');
                    return;
                }

                const idToken = decodeIdToken();
                const metadataToken = decodeMetadataToken();
                
                // Track successful SSO login
                // const successData = {
                //     'Provider': provider,
                //     'User Email': idToken?.email || '',
                //     'User Name': idToken?.name || '',
                //     'Is Registration': isRegistration,
                //     'Page Title': document.title,
                //     'Page URL': window.location.href,
                //     'Timestamp': new Date().toISOString(),
                // };
                // CleverTapService.trackEvent('SSO Login Successful', successData);

                // Update user profile in CleverTap
                if (idToken?.email) {
                    // const userData = {
                    //     Email: idToken.email,
                    //     Name: idToken.name || idToken.email.split('@')[0],
                    // };
                    // CleverTapService.updateUserProfile(userData);
                }
                
                //User have a preferred_username when they login with SSO
                if(idToken?.preferred_username) {

                    //User have a preferred_username when they login with SSO and no subscription then we need to redirect to SSO signup page
                    if(metadataToken.companies[0].subscription == null) {
                        // Track existing user without subscription
                        // const noSubscriptionData = {
                        //     'Provider': provider,
                        //     'User Email': idToken?.email || '',
                        //     'Page Title': document.title,
                        //     'Page URL': window.location.href,
                        //     'Timestamp': new Date().toISOString(),
                        // };
                        // CleverTapService.trackEvent('Existing User No Subscription', noSubscriptionData);
                        
                        const params = new URLSearchParams({
                            planId: planId
                        });
                        // Redirect to SSO signup page when subscription is null
                        navigate(`/sso-signup?${params.toString()}`);
                        return;
                    }

                    //User have a preferred_username when they login with SSO and subscription then we need to redirect to dashboard
                    console.log('No preferred_username, redirecting to dashboard');
                    navigate('/dashboard/overview?redirect=easywebinar');
                    return;
                }

                //Otherwise, user is new and we need to redirect to SSO signup page
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.delete('code');
                window.history.replaceState({}, '', newUrl);

                // Construct redirect URL with parameters
                const params = new URLSearchParams({
                    ...(planId && { planId })
                });

                if(planId === 'free-trial-plan'){
                    // Track free trial subscription creation
                    // const freeTrialData = {
                    //     'Provider': provider,
                    //     'User Email': idToken?.email || '',
                    //     'Plan ID': planId,
                    //     'Page Title': document.title,
                    //     'Page URL': window.location.href,
                    //     'Timestamp': new Date().toISOString(),
                    // };
                    // CleverTapService.trackEvent('Free Trial Subscription Created', freeTrialData);
                    
                    const customerId = metadataToken.companies[0].id;
                    const basePlanId = 'free-trial-plan';
                    await chargebeeService.createSubscription(customerId, basePlanId);
                    navigate('/dashboard/overview?redirect=easywebinar');
                    return;
                } else {
                    // Track new user redirect to signup
                    // const newUserData = {
                    //     'Provider': provider,
                    //     'User Email': idToken?.email || '',
                    //     'Plan ID': planId,
                    //     'Page Title': document.title,
                    //     'Page URL': window.location.href,
                    //     'Timestamp': new Date().toISOString(),
                    // };
                    // CleverTapService.trackEvent('New User Redirected to Signup', newUserData);
                    
                    // Redirect to SSO signup page with user info
                    if (stateData?.flow === 'first-flow') {
                        //Navigate to SSO signup page with planId if flow is first-flow
                        navigate(`/sso-signup?${params.toString()}`);
                    } else {
                        //Navigate to signup-flow page if flow is second-flow
                        navigate('/signup-flow?isSSOFlow=true');
                    }
                }
            } catch (error) {
                console.error('SSO callback error:', error);
                
                // Track SSO callback error
                // const errorData = {
                //     'Error Type': error instanceof Error ? error.message : 'Unknown Error',
                //     'Page Title': document.title,
                //     'Page URL': window.location.href,
                //     'Timestamp': new Date().toISOString(),
                // };
                // CleverTapService.trackError('SSO Callback Error', error instanceof Error ? error.message : 'Unknown Error', {}, errorData);
                
                navigate('/signup');
            }
        };

        handleSsoCallback();
    }, [navigate, searchParams]);

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
            <CircularProgress />
        </Box>
    );
};

export default SSOCallback;